var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66602 13.3333C4.66602 8.30498 4.66602 5.79082 6.32574 4.22872C7.98547 2.66663 10.6568 2.66663 15.9993 2.66663H17.0297C21.3779 2.66663 23.5521 2.66663 25.0619 3.73041C25.4945 4.0352 25.8786 4.39666 26.2024 4.80381C27.3327 6.22486 27.3327 8.2711 27.3327 12.3636V15.7575C27.3327 19.7084 27.3327 21.6839 26.7074 23.2616C25.7023 25.7981 23.5765 27.7988 20.8815 28.7448C19.2052 29.3333 17.1063 29.3333 12.9084 29.3333C10.5097 29.3333 9.3103 29.3333 8.35238 28.997C6.8124 28.4564 5.59768 27.3132 5.0233 25.8638C4.66602 24.9622 4.66602 23.8334 4.66602 21.5757V13.3333Z",
    stroke: "#00B896",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3333 16C27.3333 18.4546 25.3435 20.4444 22.8889 20.4444C22.0012 20.4444 20.9546 20.2889 20.0915 20.5202C19.3246 20.7256 18.7256 21.3246 18.5202 22.0915C18.2889 22.9546 18.4444 24.0012 18.4444 24.8889C18.4444 27.3435 16.4546 29.3333 14 29.3333",
    stroke: "#00B896",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.666 9.33325H19.9993",
    stroke: "#00B896",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.666 14.6666H14.666",
    stroke: "#00B896",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile01);
export default __webpack_public_path__ + "static/media/file-01.7967fcf5c6b93c59754672364a872bfe.svg";
export { ForwardRef as ReactComponent };